import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { LedgerArray, ListWorkshopJobTypes, ListWorkshopTasks, ListWorkshopTasksArray, ResourceList } from '@pos-app/data';
import { MatSort } from '@angular/material/sort';
import { EventService } from '@pos-app/core-ui';
import { delay, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';
import { Subject, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import moment from 'moment';

@Component({
  selector: 'app-taskDetailCard',
  styleUrls: ['./taskDetailCard.component.scss'],
  templateUrl: './taskDetailCard.component.html',
})
export class NgbdModalTaskDetailCard implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('focus', { static: false }) resourceDesc1: ElementRef;
  @ViewChild('content') modalBox: any;
  @ViewChild('filterInput') filterInput: ElementRef;
  unSubscribe$ = new Subject<void>();
  @Input() resourceList: Array<ResourceList>;
  @Input() defaultBranch: string;
  @Input() currentDate: string;
  @Input() actionTaskDetailCard: boolean;
  @Input() currentTaskData: any;
  @Input() jobTypeList: Array<ListWorkshopTasksArray>;
  ledgerResultArray: Array<LedgerArray>;


  taskDetailCardForm: FormGroup;
  resourceSettings: IDropdownSettings = {};
  otherResourceSettings: IDropdownSettings = {};
  technicianResourceList = [];
  selectedResourceList = [];
  selectedOtherResourceList = [];
  otherResourceList = [];
  isFormValid: boolean = false;
  defaultCompanyCode: string = JSON.parse(localStorage.getItem('jdeSession')).CompanyCode;
  scheduledHours: number;
  taskDescription: string;
  isNewEvent: boolean = false;
  constructor(public activeModal: NgbActiveModal, private eventService: EventService) {}
  scheduleTaskHistoryView: boolean = false;

  ngOnInit() {
    this.technicianResourceList = this.resourceList?.filter((el) => el.genericResourceTF !== true);
    this.otherResourceList = this.resourceList?.filter((el) => el.genericResourceTF === true);
    this.scheduledHours = this.currentTaskData?.data?.ScheduledHours;
    if (this.currentTaskData?.text === 'New event' && !this.currentTaskData?.keyCode) {
      this.isNewEvent = true;
      //get selected resources and populate on respective selected resource field
      this.selectedResourceList = this.technicianResourceList?.filter((item) => item.resourceID === this.currentTaskData?.section_id);
      this.selectedOtherResourceList = this.otherResourceList?.filter((item) => item.resourceID === this.currentTaskData?.section_id);
      this.scheduledHours = Number(
        moment
          .duration(moment(this.currentTaskData?.end_date, 'HH:mm').diff(moment(this.currentTaskData?.start_date, 'HH:mm')))
          .asHours()
          .toFixed(2)
      );

      //get scheduled event hrs and populated on respective scheduled hrs field
    }
    //get filtered resource list and other resource list
    else {
      this.isNewEvent = false;
      const resourceListSet = new Set(this.currentTaskData?.data?.ResourceAssigned?.map((item) => item.ResourceID));
      this.selectedResourceList = this.technicianResourceList?.filter((item) => resourceListSet.has(item.resourceID));
      this.selectedOtherResourceList = this.otherResourceList?.filter((item) => resourceListSet.has(item.resourceID));
    }
    //check if new event to create

    //get selected resource list and get selected other resource list
    this.resourceSettings = {
      singleSelection: false,
      idField: 'resourceID',
      textField: 'resourceName',
      enableCheckAll: false,
      noDataAvailablePlaceholderText: 'No Resource Found',
      allowSearchFilter: true,
      clearSearchFilter: true,
      maxHeight: 100,
      itemsShowLimit: 10,
      searchPlaceholderText: 'Search Technician',
      closeDropDownOnSelection: false,
    };
    this.otherResourceSettings = {
      singleSelection: false,
      idField: 'resourceID',
      textField: 'resourceName',
      enableCheckAll: false,
      noDataAvailablePlaceholderText: 'No Other Resource Found',
      allowSearchFilter: true,
      clearSearchFilter: true,
      maxHeight: 200,
      itemsShowLimit: 10,
      searchPlaceholderText: 'Search Other Resource',
      closeDropDownOnSelection: false,
    };

    this.taskDetailCardForm = new FormGroup({
      technicianResource: new FormControl(this.selectedResourceList, this.selectedResourceList.length > 0 ? Validators.required : []),
      otherResource: new FormControl(this.selectedOtherResourceList, this.selectedOtherResourceList.length > 0 ? Validators.required : []),
      jobTypeCode: new FormControl(this.isNewEvent ? this.jobTypeList[0].code : this.currentTaskData?.data?.TaskCode, Validators.required),
      jobDescription: new FormControl(
        this.isNewEvent ? this.jobTypeList[0].shortDescription + ' : ' : this.currentTaskData?.data?.TaskDescription,
        Validators.required
      ),
      scheduledHours: new FormControl(this.scheduledHours, Validators.required),
      currentTaskData: new FormControl(this.currentTaskData?.data),
      isNewEvent: new FormControl(this.isNewEvent),
    });
    this.taskDetailCardForm.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.isFormValid = true;
    });

    this.taskDetailCardForm
      .get('technicianResource')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe(() => {
        const val = this.taskDetailCardForm.getRawValue();
        if (val.technicianResource.length > 0 || val.otherResource.length > 0) {
          this.taskDetailCardForm.get('technicianResource').setValidators(null);
          this.taskDetailCardForm.get('otherResource').setValidators(null);
          this.taskDetailCardForm.get('technicianResource').updateValueAndValidity();
          this.taskDetailCardForm.get('otherResource').updateValueAndValidity();
        } else {
          this.taskDetailCardForm.get('technicianResource').setValidators(Validators.required);
          this.taskDetailCardForm.get('technicianResource').updateValueAndValidity();
          this.taskDetailCardForm.get('otherResource').setValidators(Validators.required);
          this.taskDetailCardForm.get('otherResource').updateValueAndValidity();
        }
      });
    this.taskDetailCardForm
      .get('otherResource')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe(() => {
        const val = this.taskDetailCardForm.getRawValue();
        if (val.technicianResource.length > 0 || val.otherResource.length > 0) {
          this.taskDetailCardForm.get('technicianResource').setValidators(null);
          this.taskDetailCardForm.get('otherResource').setValidators(null);
          this.taskDetailCardForm.get('technicianResource').updateValueAndValidity();
          this.taskDetailCardForm.get('otherResource').updateValueAndValidity();
        } else if (this.resourceList.length > 0) {
          this.taskDetailCardForm.get('technicianResource').setValidators(Validators.required);
          this.taskDetailCardForm.get('technicianResource').updateValueAndValidity();
          this.taskDetailCardForm.get('otherResource').setValidators(Validators.required);
          this.taskDetailCardForm.get('otherResource').updateValueAndValidity();
        }
      });

    this.taskDetailCardForm
      .get('jobTypeCode')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe(() => {
        const val = this.taskDetailCardForm.getRawValue();
        if (val.jobTypeCode) {
          this.taskDetailCardForm.patchValue({
            jobDescription:
              this.jobTypeList.filter((el) => {
                return el.code === val.jobTypeCode;
              })[0].shortDescription + ' : ',
          });
        }
      });
  }

  submittaskDetailCardForm(submit) {
    if (submit) {
      this.activeModal.close(this.taskDetailCardForm?.value);
      this.actionTaskDetailCard = false;
    }
  }

  handleCloseModal(event) {
    if (event) {
      this.actionTaskDetailCard = false;
      this.activeModal.close();
    }
  }

  viewScheduleHistory() {
    this.eventService
      .fetchOrderLedger({ jobID: this.currentTaskData?.data?.JobID})
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.ledgerResultArray = data?.ledgerArray;
        this.actionTaskDetailCard = false;
        this.scheduleTaskHistoryView = true;
      });
  }
}
